/* PACKAGES */
import { motion } from "framer-motion";

/* ANIMATION */
import { animation } from "config";

const StoryLine = () => {
  return (
    <motion.div variants={animation} className="py-6 xl:py-12 lg:py-12">
      <div className="container">
        {/* SECTION ONE */}
        <div className="block xl:flex lg:flex items-center justify-between gap-5">
          {/* LEFT SECTION */}
          <div className="w-full xl:w-[47.5%] lg:w-[47.5%] pr-5">
            <h5 className="text-3xl font-roundo font-bold text-black">
              Where it all began?
            </h5>
            <div className="mt-5">
              <p className="text-lg font-source font-normal text-greyText leading-relaxed">
                When the founder of Alumni Connection Hub, Vimal Patel, an
                alumnus of RCPIT and now the driving force behind the IT company
                RoundTech Square, returned to his alma mater, it was not a
                simple nostalgia trip. Meeting old friends, exploring the same
                corridors, and reminiscing about “those days” prompted an
                intense thought: there is no meaningful, effective system for
                alumni to stay connected.{" "}
              </p>
              <p className="mt-5 text-lg font-source font-normal text-greyText leading-relaxed">
                The continued spontaneous conversations fueled the realization
                that while some bonds remained, most alumni cannot find their
                batchmates who have moved to different parts of the world. It
                ignited a moment of spark in Vimal, which prompted the idea to
                create Alumni Connection Hub.
              </p>
              <p className="mt-5 text-lg font-source font-normal text-greyText leading-relaxed">
                He took the idea to Raju Bhandari and JB Patil, the inspiration
                behind this tool, who positively nodded along with this idea.
                Backed by their encouragement and guidance from Mr. Deore and
                Mr. Jadhav, the idea was then pitched to the principal, who
                loved the idea of the concept of “Built by an alumnus, for the
                alumni.” That wasn’t all; he also opened the doors for four
                third-year students to pursue their internships by working on
                this project to initiate real-world experience for these future
                innovators.
              </p>
            </div>
          </div>

          {/* RIGHT SECTION */}
          <div className="mt-5 xl:mt-0 lg:mt-0 w-full xl:w-[47.5%] lg:w-[47.5%]">
            <img
              src={require("../../assets/images/storyline-01.jpeg")}
              className="w-full h-[30vh] object-cover rounded-lg"
              alt="Where it all began"
            />

            <div className="mt-5">
              <img
                src={require("../../assets/images/storyline-02.jpeg")}
                className="w-full h-[30vh] object-cover rounded-lg"
                alt="Where it all began"
              />
            </div>
          </div>
        </div>

        {/* SECTION TWO */}
        <div className="pt-10 xl:pt-20 lg:pt-20">
          <div className="block xl:flex lg:flex items-center justify-between gap-5">
            {/* LEFT SECTION */}
            <div className="w-full xl:w-[47.5%] lg:w-[47.5%] order-2 xl:order-1 lg:order-1">
              <img
                src={require("../../assets/images/storyline-03.jpeg")}
                className="w-full h-[40vh] xl:h-[60vh] lg:h-[60vh] object-cover rounded-lg"
                alt="Where it all began"
              />
            </div>

            {/* RIGHT SECTION */}
            <div className="mt-5 xl:mt-0 lg:mt-0 w-full xl:w-[47.5%] lg:w-[47.5%] pr-5 order-1 xl:order-2 lg:order-2">
              <h5 className="text-3xl font-roundo font-bold text-black">
                Built by the Alumni, for the Alumni
              </h5>
              <div className="mt-5">
                <p className="text-lg font-source font-normal text-greyText leading-relaxed">
                  The journey chronicled here commenced with RCPIT alumni Vimal
                  Patel joining hands with Anjali Kakkar P, another alumni of
                  RCPIT, wanting to address a gap they felt existed. They
                  stepped into leadership positions where they noticed how
                  fragmented alumni networks had become. This was not because of
                  a lack of effort, but due to a lack of systems.
                </p>
                <p className="mt-5 text-lg font-source font-normal text-greyText leading-relaxed">
                  Systems is where these two went right in building the
                  framework and ideating the software in what would later become
                  the Alumni Connection Hub. They started by asking the critical
                  question, “In what way can we enable easier involvement,
                  connectivity, visibility, and overall alumni engagement?” It
                  was like a trickle that transformed into a flood.
                </p>
                <p className="mt-5 text-lg font-source font-normal text-greyText leading-relaxed">
                  At RoundTechSquare, developers Darsh Shah and Abhishek Kumar
                  began transforming that blueprint into something real. They
                  did not work robotically, ensuring they covered everything on
                  the checklist. They were part of the story, too. As part of
                  the framework, they understood the sharp focus behind each
                  part and the impact of creating something tangible that would
                  resonate deeply with thousands, including themselves, one day,
                  hopefully. The outcome was a well-crafted and effective
                  platform.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* SECTION THREE */}
        <div className="pt-10 xl:pt-20 lg:pt-20">
          <div className="bg-white border border-logo/20 rounded-2xl shadow-lg shadow-logo/20 p-5 xl:p-10 lg:p-10">
            <div className="grid grid-cols-1 xl:grid-cols-2 lg:grid-cols-2 gap-y-10 xl:gap-20 lg:gap-20">
              <div className="col-span-1">
                <h2 className="text-3xl font-roundo font-bold text-black">
                  A Community That Grows Together
                </h2>
                <h5 className="w-full xl:w-4/5 lg:w-4/5 text-lg font-source font-normal text-greyText leading-relaxed mt-3">
                  What started as a single campus concept is now evolving into
                  something much larger for the alumni community.
                </h5>
              </div>
              <div className="col-span-1">
                <h5 className="text-lg font-source font-normal text-greyText leading-relaxed mt-0">
                  The Alumni Connection Hub is fully prepared for expansion and
                  will soon be presented to select colleges and educational
                  institutions nationwide. The goals are straightforward: build
                  vibrant alumni communities that are not just defined by
                  sporadic reunions and passive rosters.
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default StoryLine;
